export default "__VITE_ASSET__165878f6__"